import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import BlogList from './pages/BlogList';
import BlogPost from './pages/BlogPost';
import Certificates from './pages/Certificates';
import Social from './pages/Social';

function App() {
  return (
    <HelmetProvider>
      <div className="min-h-screen">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/social" element={<Social />} />
        </Routes>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
